import {JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {ButtonBase} from "@/shared/ui/buttons";
import {Typography} from "@/shared/ui/data-display/typography";
import {assetPath} from "@/shared/utils/asset-path";

import "./styles/more-questions.scss";

export type MoreQuestionsProps = {
    title: string;
    description: string;
    do_text: string;
    button: {
        text: string;
        href: string;
    };
};

export function MoreQuestions({title, description, do_text, button}: MoreQuestionsProps): JSX.Element {
    return (
        <div className="more-questions">
            <SmartImage src={assetPath("/images/faq/faq-image.png")} alt="More questions" width={101} height={98} className="more-questions__image" />
            <Typography as="h3" size={{desktop: 22, mobile: 18}} weight={500} className="more-questions__title">
                {title}
            </Typography>
            {description && (
                <Typography
                    as="p"
                    size={{desktop: 16, mobile: 14}}
                    weight={400}
                    lineHeight={150}
                    className="more-questions__description"
                    color="title"
                >
                    {description}
                </Typography>
            )}
            {do_text && (
                <Typography as="p" size={{desktop: 16, mobile: 14}} weight={400} lineHeight={150} color="title" className="more-questions__do-text">
                    {do_text}
                </Typography>
            )}
            {button && (
                <div className="more-questions__button">
                    <ButtonBase width="full" as="link" href={button.href} size="lg">
                        {button.text}
                    </ButtonBase>
                </div>
            )}
        </div>
    );
}
